import { Category } from './category';

export class CategoryImage {
    category: Category = new Category();
    customFile: string = "";
}